import experiment from 'experiment';
import * as appStudioUtils from '../appStudio/appStudioUtils';
import { isResponsiveEditor } from '@wix/santa-editor-utils';

export const isNewPanelEnabled = (): boolean =>
  !isResponsiveEditor() && !appStudioUtils.isAppStudio();

export const isAddPanelRegistrySectionEnabled = (): boolean =>
  isNewPanelEnabled() && experiment.isOpen('apd_elementsRegistryDev');
